<div class="modal-overlay reorder-modal-overlay" (click)="onBackdropClick()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Equipment-Asset Reorder</h2>
      <button class="close-btn" (click)="close()">✕</button>
    </div>

    <div class="tabs">
      <button
        *ngFor="let type of entityTypes"
        (click)="onEntityTypeSelect(type)"
        [class.active]="type === selectedEntityType"
      >
        {{ entityTypeLabels[type] || "Unknown" }}
      </button>
    </div>

    <div class="sub-title">
      Equipment <span class="reorder-hint">(drag to reorder)</span>
    </div>

    <div
      class="drag-list"
      cdkDropList
      (cdkDropListDropped)="onDrop($event)"
      [cdkDropListData]="filteredSections"
    >
      <div
        class="drag-item"
        *ngFor="let item of filteredSections; trackBy: trackById"
        cdkDrag
      >
        <div class="left-content">
          <span class="drag-handle" cdkDragHandle>
            <svg
              width="25"
              height="16"
              viewBox="0 0 10 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.99347 15.2311C1.655 15.2311 1.36526 15.1106 1.12424 14.8695C0.883211 14.6285 0.762695 14.3388 0.762695 14.0003C0.762695 13.6618 0.883211 13.3721 1.12424 13.1311C1.36526 12.8901 1.655 12.7695 1.99347 12.7695C2.33194 12.7695 2.62168 12.8901 2.86269 13.1311C3.10373 13.3721 3.22424 13.6618 3.22424 14.0003C3.22424 14.3388 3.10373 14.6285 2.86269 14.8695C2.62168 15.1106 2.33194 15.2311 1.99347 15.2311ZM7.99347 15.2311C7.655 15.2311 7.36526 15.1106 7.12424 14.8695C6.88321 14.6285 6.76269 14.3388 6.76269 14.0003C6.76269 13.6618 6.88321 13.3721 7.12424 13.1311C7.36526 12.8901 7.655 12.7695 7.99347 12.7695C8.33193 12.7695 8.62168 12.8901 8.86269 13.1311C9.10373 13.3721 9.22424 13.6618 9.22424 14.0003C9.22424 14.3388 9.10373 14.6285 8.86269 14.8695C8.62168 15.1106 8.33193 15.2311 7.99347 15.2311ZM1.99347 9.23108C1.655 9.23108 1.36526 9.11057 1.12424 8.86953C0.883211 8.62852 0.762695 8.33878 0.762695 8.00031C0.762695 7.66184 0.883211 7.3721 1.12424 7.13108C1.36526 6.89005 1.655 6.76953 1.99347 6.76953C2.33194 6.76953 2.62168 6.89005 2.86269 7.13108C3.10373 7.3721 3.22424 7.66184 3.22424 8.00031C3.22424 8.33878 3.10373 8.62852 2.86269 8.86953C2.62168 9.11057 2.33194 9.23108 1.99347 9.23108ZM7.99347 9.23108C7.655 9.23108 7.36526 9.11057 7.12424 8.86953C6.88321 8.62852 6.76269 8.33878 6.76269 8.00031C6.76269 7.66184 6.88321 7.3721 7.12424 7.13108C7.36526 6.89005 7.655 6.76953 7.99347 6.76953C8.33193 6.76953 8.62168 6.89005 8.86269 7.13108C9.10373 7.3721 9.22424 7.66184 9.22424 8.00031C9.22424 8.33878 9.10373 8.62852 8.86269 8.86953C8.62168 9.11057 8.33193 9.23108 7.99347 9.23108ZM1.99347 3.23108C1.655 3.23108 1.36526 3.11057 1.12424 2.86953C0.883211 2.62852 0.762695 2.33877 0.762695 2.00031C0.762695 1.66184 0.883211 1.3721 1.12424 1.13108C1.36526 0.890049 1.655 0.769531 1.99347 0.769531C2.33194 0.769531 2.62168 0.890049 2.86269 1.13108C3.10373 1.3721 3.22424 1.66184 3.22424 2.00031C3.22424 2.33877 3.10373 2.62852 2.86269 2.86953C2.62168 3.11057 2.33194 3.23108 1.99347 3.23108ZM7.99347 3.23108C7.655 3.23108 7.36526 3.11057 7.12424 2.86953C6.88321 2.62852 6.76269 2.33877 6.76269 2.00031C6.76269 1.66184 6.88321 1.3721 7.12424 1.13108C7.36526 0.890049 7.655 0.769531 7.99347 0.769531C8.33193 0.769531 8.62168 0.890049 8.86269 1.13108C9.10373 1.3721 9.22424 1.66184 9.22424 2.00031C9.22424 2.33877 9.10373 2.62852 8.86269 2.86953C8.62168 3.11057 8.33193 3.23108 7.99347 3.23108Z"
                fill="#151918"
                fill-opacity="0.8"
              />
            </svg>
          </span>
          <div class="item-content">{{ item.name }}</div>
        </div>

        <div class="dots-wrapper position-relative">
          <span class="icon dots" (click)="onDotsClick(item)">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 1.5C8.27513 1.5 7.6875 2.08763 7.6875 2.8125C7.6875 3.53738 8.27513 4.125 9 4.125C9.72488 4.125 10.3125 3.53738 10.3125 2.8125C10.3125 2.08763 9.72488 1.5 9 1.5Z"
                fill="black"
              />
              <path
                d="M9 7.6875C8.27513 7.6875 7.6875 8.27513 7.6875 9C7.6875 9.72488 8.27513 10.3125 9 10.3125C9.72488 10.3125 10.3125 9.72488 10.3125 9C10.3125 8.27513 9.72488 7.6875 9 7.6875Z"
                fill="black"
              />
              <path
                d="M9 13.875C8.27513 13.875 7.6875 14.4626 7.6875 15.1875C7.6875 15.9124 8.27513 16.5 9 16.5C9.72488 16.5 10.3125 15.9124 10.3125 15.1875C10.3125 14.4626 9.72488 13.875 9 13.875Z"
                fill="black"
              />
            </svg>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="delete-modal-overlay" *ngIf="showDeleteModal" (click)="onBackdropClick()">
  <div class="delete-modal" (click)="$event.stopPropagation()">
    <div class="delete-icon">
      <span class="circle">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.58393 5C8.28068 3.24301 9.99487 2 12.0009 2C14.007 2 15.7212 3.24301 16.4179 5H21.25C21.6642 5 22 5.33579 22 5.75C22 6.16421 21.6642 6.5 21.25 6.5H19.9532L19.1795 18.4914C19.0522 20.4647 17.4146 22 15.4373 22H8.56269C6.58535 22 4.94777 20.4647 4.82047 18.4914L4.04683 6.5H2.75C2.33579 6.5 2 6.16421 2 5.75C2 5.33579 2.33579 5 2.75 5H7.58393ZM9.26161 5C9.83935 4.09775 10.8509 3.5 12.0009 3.5C13.151 3.5 14.1625 4.09775 14.7403 5H9.26161ZM10.5 10.75C10.5 10.3358 10.1642 10 9.75 10C9.33579 10 9 10.3358 9 10.75V16.25C9 16.6642 9.33579 17 9.75 17C10.1642 17 10.5 16.6642 10.5 16.25V10.75ZM14.25 10C14.6642 10 15 10.3358 15 10.75V16.25C15 16.6642 14.6642 17 14.25 17C13.8358 17 13.5 16.6642 13.5 16.25V10.75C13.5 10.3358 13.8358 10 14.25 10Z"
            fill="#DF5050"
          />
        </svg>
      </span>
    </div>
    <h3>Confirm Deletion</h3>
    <p>
      Are you sure you want to delete this? Once it’s gone, you can’t undo it.
    </p>
    <div class="modal-actions">
      <button class="btn-delete" (click)="confirmDelete()">Yes Delete</button>
      <button class="btn-cancel" (click)="cancelDelete()">Cancel</button>
    </div>
  </div>
</div>
